import { render, staticRenderFns } from "./ModalAcceptedHistory.vue?vue&type=template&id=745ed17c&scoped=true&"
import script from "./ModalAcceptedHistory.vue?vue&type=script&lang=js&"
export * from "./ModalAcceptedHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModalAcceptedHistory.vue?vue&type=style&index=0&id=745ed17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ed17c",
  null
  
)

export default component.exports